/**
 * Pháp luật (Thanh Tịnh Pháp — Tuân thủ Pháp luật) route family — Plans 7.2 decomposition.
 * All routes are direct children of _authenticated (authenticatedRoute).
 */
import { lazy } from "react";
import { createRoute } from "@tanstack/react-router";

import { authenticatedRoute } from "../__root.js";
import { withSuspense } from "../route-helpers.js";

// ── Lazy page imports ────────────────────────────────────────────────

const CharitiesPage = lazy(() =>
  import("@/features/dharma-compliance").then((mod) => ({ default: mod.CharitiesPage })),
);
const FraudAlertsPage = lazy(() =>
  import("@/features/dharma-compliance").then((mod) => ({ default: mod.FraudAlertsPage })),
);
const PurityVowsPage = lazy(() =>
  import("@/features/dharma-compliance").then((mod) => ({ default: mod.PurityVowsPage })),
);
const GuidanceQueuePage = lazy(() =>
  import("@/features/dharma-compliance").then((mod) => ({ default: mod.GuidanceQueuePage })),
);
const CharityCreatePage = lazy(() =>
  import("@/features/dharma-compliance").then((mod) => ({ default: mod.CharityCreatePage })),
);
const CharityDetailPage = lazy(() =>
  import("@/features/dharma-compliance").then((mod) => ({ default: mod.CharityDetailPage })),
);

// ── Routes ───────────────────────────────────────────────────────────

const charitiesRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: "/phap-luat/to-chuc-tu-thien",
  component: withSuspense(CharitiesPage),
});
const charityCreateRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: "/phap-luat/to-chuc-tu-thien/tao-moi",
  component: withSuspense(CharityCreatePage),
});
const charityDetailRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: "/phap-luat/to-chuc-tu-thien/$charityId",
  component: withSuspense(CharityDetailPage),
});
const fraudAlertsRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: "/phap-luat/canh-bao-gian-lan",
  component: withSuspense(FraudAlertsPage),
});
const purityVowsRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: "/phap-luat/loi-nguyen-thanh-tu",
  component: withSuspense(PurityVowsPage),
});
const guidanceQueueRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: "/phap-luat/hang-doi-huong-dan",
  component: withSuspense(GuidanceQueuePage),
});

export const phapLuatRoutes = [
  charitiesRoute,
  charityCreateRoute,
  charityDetailRoute,
  fraudAlertsRoute,
  purityVowsRoute,
  guidanceQueueRoute,
];
